import UserManagement from "../pages/Admin/User/Management"
import UserEdit from "../pages/Admin/User/Fields"
import UserCreate from "../pages/Admin/User/Fields"
import MediaManagement from "../pages/Admin/Media/Management"
import CalendarioManagement from "../pages/Admin/Calendario/Management"
import TrabajosManagement from "../pages/Admin/Trabajos/Management"
import FacturasManagement from "../pages/Admin/Facturas/Management"
import TipoServiciosManagement from "../pages/Admin/TipoServicios/Management"
import TipoServiciosFields from "../pages/Admin/TipoServicios/Fields"
import LogReport from "../pages/Admin/Log/LogReport"
import LogMail from "../pages/Admin/Log/LogMail"
import DocInstall from "../pages/Admin/Doc/DocInstall"
import ProviderManagement from "../pages/Admin/Provider/Management"
import ProviderEdit from "../pages/Admin/Provider/Fields"
import ProviderCreate from "../pages/Admin/Provider/Fields"
import ProviderRecordManagement from "../pages/Admin/ProviderRecords/Management"
import OrganizationdManagement from "../pages/Admin/Organization/Management"
import GestionGeografica from "../pages/Admin/GestionGeografica/Management"
import PresupuestoManagement from "../pages/Admin/Presupuesto/Management"
import TicketsManagement from "../pages/Admin/Tickets/Management"
import DeliveryNoteManagement from "../pages/Admin/DeliveryNote/Management"
import SimpleInvoiceManagement from "../pages/Admin/SimpleInvoice/Management"
import VerifactuManagement from "../pages/Admin/Verifactu/Management"

const baseTitle = "Gmatik - "
const urlBase = "/dash-admin"

export const RouteAdmin = {
    USER_MANAGEMENT: {
        path: `${urlBase}/users/management`,
        menu: "user",
        menuChild: "",
        page: UserManagement,
        title: `${baseTitle}User Management`,
        roles: ["ROLE_ADMIN"]
    },
    USER_EDIT: {
        path: `${urlBase}/users/edit`,
        menu: "user",
        menuChild: "",
        params: "/:id",
        page: UserEdit,
        title: `${baseTitle}User Edit`,
        roles: ["ROLE_ADMIN"]
    },
    USER_CREATE: {
        path: `${urlBase}/users/create`,
        menu: "user",
        menuChild: "",
        page: UserCreate,
        title: `${baseTitle}User Create`,
        roles: ["ROLE_ADMIN"]
    },
    MEDIA_MANAGEMENT: {
        path: `${urlBase}/media/management`,
        menu: "media",
        menuChild: "",
        page: MediaManagement,
        title: `${baseTitle}Media Management`,
        roles: ["ROLE_ADMIN"]
    },
    LOG_REPORT: {
        path: `${urlBase}/logs/report`,
        menu: "log",
        menuChild: "report",
        page: LogReport,
        title: `${baseTitle}Log Report`,
        roles: ["ROLE_ADMIN"]
    },
    LOG_MAIL: {
        path: `${urlBase}/logs/mail`,
        menu: "log",
        menuChild: "mail",
        page: LogMail,
        title: `${baseTitle}Log Mail`,
        roles: ["ROLE_ADMIN"]
    },
    DOC_INSTALL: {
        path: `${urlBase}/doc/install`,
        menu: "doc",
        menuChild: "install",
        page: DocInstall,
        title: `${baseTitle}Doc Install`,
        roles: ["ROLE_ADMIN"]
    },
    CALENDARIO_MANAGEMENT: {
        path: `${urlBase}/calendario/management`,
        menu: "calendario",
        menuChild: "",
        page: CalendarioManagement,
        title: `${baseTitle}Calendario Management`,
        roles: ["ROLE_ADMIN", "ROLE_MANAGER"]
    },
    TRABAJOS_MANAGEMENT: {
        path: `${urlBase}/trabajos/management`,
        menu: "trabajos",
        menuChild: "",
        page: TrabajosManagement,
        title: `${baseTitle}Trabajos Management`,
        roles: ["ROLE_ADMIN", "ROLE_MANAGER"]
    },
    FACTURAS_MANAGEMENT: {
        path: `${urlBase}/facturas/management`,
        menu: "facturas",
        menuChild: "",
        page: FacturasManagement,
        title: `${baseTitle}Facturas Management`,
        roles: ["ROLE_ADMIN"]
    },
    TIPO_SERVICIOS_MANAGEMENT: {
        path: `${urlBase}/tipo-servicios/management`,
        menu: "tipoServicios",
        menuChild: "",
        page: TipoServiciosManagement,
        title: `${baseTitle}Tipo Servicio Management`,
        roles: ["ROLE_ADMIN"]
    },
    TIPO_SERVICIOS_CREATE: {
        path: `${urlBase}/tipo-servicios/create`,
        menu: "tipoServicios",
        menuChild: "",
        page: TipoServiciosFields,
        title: `${baseTitle}Tipo Servicio Create`,
        roles: ["ROLE_ADMIN"]
    },
    TIPO_SERVICIOS_EDIT: {
        path: `${urlBase}/tipo-servicios/edit`,
        params: "/:id",
        menu: "tipoServicios",
        menuChild: "",
        page: TipoServiciosFields,
        title: `${baseTitle}Tipo Servicio Edit`,
        roles: ["ROLE_ADMIN"]
    },
    PROVIDER_MANAGEMENT: {
        path: `${urlBase}/proveedores/management`,
        menu: "proveedores",
        menuChild: "",
        page: ProviderManagement,
        title: `${baseTitle}Proveedores Management`,
        roles: ["ROLE_ADMIN"]
    },
    PROVIDER_EDIT: {
        path: `${urlBase}/proveedores/edit`,
        menu: "proveedores",
        menuChild: "",
        params: "/:id",
        page: ProviderEdit,
        title: `${baseTitle}Proveedores Edit`,
        roles: ["ROLE_ADMIN"]
    },
    PROVIDER_CREATE: {
        path: `${urlBase}/proveedores/create`,
        menu: "proveedores",
        menuChild: "",
        page: ProviderCreate,
        title: `${baseTitle}Proveedores Create`,
        roles: ["ROLE_ADMIN"]
    },
    PROVIDER_RECORD_MANAGEMENT: {
        path: `${urlBase}/gestion-proveedores/management`,
        menu: "gestionProveedores",
        menuChild: "",
        page: ProviderRecordManagement,
        title: `${baseTitle}Gestión Proveedores Management`,
        roles: ["ROLE_ADMIN"]
    },
    ORGANIZATIONS_MANAGEMENT: {
        path: `${urlBase}/organization/management`,
        menu: "organization",
        menuChild: "",
        page: OrganizationdManagement,
        title: `${baseTitle}Gestión Organización Management`,
        roles: ["ROLE_ADMIN", "ROLE_MANAGER"]
    },
    GESTION_GEOGRAFICA: {
        path: `${urlBase}/gestion-geografica/management`,
        menu: "gestionGeografica",
        menuChild: "",
        page: GestionGeografica,
        title: `${baseTitle}Gestión Geográfica`,
        roles: ["ROLE_ADMIN", "ROLE_MANAGER"]
    },
    PRESUPUESTO_MANAGEMENT: {
        path: `${urlBase}/presupuesto/management`,
        menu: "presupuesto",
        menuChild: "",
        page: PresupuestoManagement,
        title: `${baseTitle}Presupuestos`,
        roles: ["ROLE_ADMIN"]
    },
    TICKETS_MANAGEMENT: {
        path: `${urlBase}/tickets/management`,
        menu: "tickets",
        menuChild: "",
        page: TicketsManagement,
        title: `${baseTitle}Tockets`,
        roles: ["ROLE_ADMIN"]
    },
    DELIVERY_NOTE_MANAGEMENT: {
        path: `${urlBase}/delivery-note/management`,
        menu: "deliveryNote",
        menuChild: "",
        page: DeliveryNoteManagement,
        title: `${baseTitle}Albarán Management`,
        roles: ["ROLE_ADMIN"]
    },
    SIMPLE_INVOICE_MANAGEMENT: {
        path: `${urlBase}/simple-invoice/management`,
        menu: "simpleInvoice",
        menuChild: "",
        page: SimpleInvoiceManagement,
        title: `${baseTitle}Factura Simple Management`,
        roles: ["ROLE_ADMIN"]
    },
    VERIFACTU_MANAGEMENT: {
        path: `${urlBase}/verifactu/management`,
        menu: "verifactu",
        menuChild: "",
        page: VerifactuManagement,
        title: `${baseTitle}Verifactu Management`,
        roles: ["ROLE_ADMIN"]
    }
}